import { useState, useRef } from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import Input from "components/inputs";
import PdfViewer from "components/pdfViewr";
import { convertAmountFaToEn } from "containers/pmaOnboarding/services/data.transformers";

import SubmitButton from "./button";
import PrePaymentCollapse from "./collapse";


const PrepaymentAmountForm = ({ amount, loading, onFinish }) => {
  const { t } = useTranslation();
  const rulesModal = useRef();
  const [form] = Form.useForm();
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const amountWatch = convertAmountFaToEn(Form.useWatch("amount", form)) ?? 0;

  const handleChangeRules = (e) => setDisabled(e.target.checked ? false : true);

  const handleRulesClick = () => rulesModal?.current?.showModal();

  const hasErrors = () => disabled || amountWatch <= 0;

  const validateAmount = (_, value) => {
    if (value?.length > 0) {
      setError(false);
      return Promise.resolve();
    }

    setError(true);
    return Promise.reject();
  };

  const onKeyDown = (e) =>
    ["e", "E", "+", "-", ",", "#", "."].includes(e.key) && e.preventDefault();

  const onChange = (e) => {
    const val = convertAmountFaToEn(e.target.value);
    const newValue = val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    form.setFieldValue("amount", newValue);
  };

  return (
    <Form
      autoComplete="off"
      form={form}
      initialValues={{ amount }}
      name="onboarding-step"
      onFinish={onFinish}
    >
      <div className="px-5 ">
        <div className="relative mt-24  [&_.ant-form-item-explain]:hidden">
          <Input
            inputClassName={`text-right transition-all delay-50 ${
              error ? "!border-error-0" : ""
            }`}
            label={t("pma-onboarding.prepayment")}
            name="amount"
            type="tel"
            validator={validateAmount}
            validateTrigger="onChange"
            inputProps={{
              maxLength: 15,
              onKeyDown,
              onChange,
            }}
          />
          <span className="absolute left-2 top-[46px] md:top-[38px] z-10 body-14px-medium text-gray-0">
            {t("rial")}
          </span>
        </div>

        <PrePaymentCollapse />
      </div>

      <SubmitButton
        disabled={hasErrors()}
        loading={loading}
        onChangeRules={handleChangeRules}
        handleRulesClick={handleRulesClick}
      />
      <PdfViewer
        pdf={`https://cdn.firouzeh.com/public/terms/term-pma.pdf`}
        modalRef={rulesModal}
      />
    </Form>
  );
};

export default PrepaymentAmountForm;
